import { render } from "./garment-power-house.vue?vue&type=template&id=69f4ba22&scoped=true"
import script from "./garment-power-house.vue?vue&type=script&lang=js"
export * from "./garment-power-house.vue?vue&type=script&lang=js"

import "./garment-power-house.vue?vue&type=style&index=0&id=69f4ba22&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f4ba22"]])

export default __exports__